import React, { type SVGProps } from "react";
import { illustrationSizes, type IllustrationProps } from "./utils/shared";
const Dashboard = (props: SVGProps<SVGSVGElement> & IllustrationProps) => (
  <svg
    width={props.size ? illustrationSizes[props.size] : illustrationSizes["s"]}
    height={props.size ? illustrationSizes[props.size] : illustrationSizes["s"]}
    viewBox="0 0 335 335"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    title="Dashboard"
    color="transparent"
    {...props}
  >
    <path
      opacity={0.18}
      d="M302.029 193.531C297.106 202.799 288.195 210.037 285.727 220.24C284.658 224.642 284.907 229.259 284.382 233.762C282.445 249.542 270.609 262.695 256.493 270.148C255.901 270.471 255.303 270.767 254.704 271.062C245.443 275.586 235.41 278.052 225.181 279.591C218.96 280.519 212.665 281.097 206.424 281.607C180.478 283.659 154.474 284.408 128.412 283.852C115.829 283.597 102.997 282.999 91.1611 278.825C90.5558 278.617 89.9573 278.395 89.3587 278.153C79.7552 274.423 71.2344 268.314 63.6887 261.311L63.3457 260.988C52.0878 250.477 42.7868 237.781 36.7678 223.607C28.1667 203.366 26.6595 180.815 32.4906 159.611C36.0482 147.01 42.2623 134.993 43.2509 121.975C43.9705 112.162 41.6637 102.229 43.2038 92.5106C46.2503 73.2218 64.1931 59.0207 83.1379 54.2422C102.083 49.4637 122.023 52.1857 141.371 54.9143C150.827 56.2585 161.89 59.8676 171.245 56.9776C182.724 53.4223 192.409 49.0269 204.796 49C209.861 49 215.025 49.5309 219.666 51.5606C225.288 54.0137 229.754 58.4629 234.307 62.5559C247.051 73.9813 261.577 83.2157 274.604 94.305C287.631 105.394 299.427 118.89 304.195 135.302C306.542 143.327 307.12 151.761 307.369 160.115C307.732 171.527 307.362 183.457 302.029 193.531Z"
      fill="#CFDAFF"
    />
    <path
      d="M236.103 125.012H104.027C98.3551 125.012 93.7573 129.607 93.7573 135.275V223.372C93.7573 229.04 98.3551 233.634 104.027 233.634H236.103C241.774 233.634 246.372 229.04 246.372 223.372V135.275C246.372 129.607 241.774 125.012 236.103 125.012Z"
      fill="#7494FF"
    />
    <path d="M237.058 132.768H103.072V223.661H237.058V132.768Z" fill="white" />
    <path d="M168.514 175.069H164.52V211.57H168.514V175.069Z" fill="#7494FF" />
    <path d="M175.462 181.037H171.467V211.57H175.462V181.037Z" fill="#7494FF" />
    <path d="M182.267 186.488H178.272V211.57H182.267V186.488Z" fill="#7494FF" />
    <path d="M189.214 181.037H185.22V211.57H189.214V181.037Z" fill="#7494FF" />
    <path d="M196.02 193.316H192.025V211.57H196.02V193.316Z" fill="#7494FF" />
    <path d="M202.967 181.037H198.973V211.57H202.967V181.037Z" fill="#7494FF" />
    <path d="M209.773 190.204H205.778V211.57H209.773V190.204Z" fill="#7494FF" />
    <path d="M216.72 186.091H212.726V211.57H216.72V186.091Z" fill="#7494FF" />
    <path d="M140.558 197.281H117.712V198.612H140.558V197.281Z" fill="#7494FF" />
    <path d="M140.558 200.971H117.712V202.302H140.558V200.971Z" fill="#7494FF" />
    <path d="M140.558 204.667H117.712V205.998H140.558V204.667Z" fill="#7494FF" />
    <path d="M140.558 208.364H117.712V209.695H140.558V208.364Z" fill="#7494FF" />
    <path d="M140.558 212.06H117.712V213.391H140.558V212.06Z" fill="#7494FF" />
    <path
      d="M141.029 150.538C137.087 150.526 133.302 152.08 130.506 154.857C127.711 157.635 126.134 161.408 126.122 165.347C126.111 169.287 127.665 173.069 130.444 175.863C133.223 178.656 136.999 180.232 140.941 180.244V175.069H140.881C138.936 175.069 137.035 174.493 135.418 173.413C133.801 172.333 132.541 170.799 131.797 169.003C131.053 167.208 130.858 165.232 131.237 163.326C131.617 161.42 132.553 159.669 133.928 158.295C135.303 156.921 137.055 155.985 138.962 155.606C140.87 155.227 142.847 155.422 144.643 156.165C146.44 156.909 147.975 158.168 149.056 159.784C150.136 161.4 150.713 163.3 150.713 165.243C150.714 165.714 150.678 166.183 150.605 166.648H155.831C155.874 166.23 155.894 165.811 155.891 165.391C155.892 163.44 155.508 161.508 154.762 159.706C154.015 157.904 152.92 156.266 151.54 154.886C150.16 153.507 148.521 152.413 146.717 151.667C144.914 150.921 142.981 150.537 141.029 150.538Z"
      fill="#7494FF"
    />
    <path
      d="M281.39 138.293H244.112C241.338 138.293 239.088 140.54 239.088 143.313V179.68C239.088 182.452 241.338 184.7 244.112 184.7H281.39C284.164 184.7 286.413 182.452 286.413 179.68V143.313C286.413 140.54 284.164 138.293 281.39 138.293Z"
      fill="url(#paint0_linear_4322_5100)"
    />
    <path
      d="M220.473 71.219H183.196C180.421 71.219 178.172 73.4667 178.172 76.2394V112.606C178.172 115.378 180.421 117.626 183.196 117.626H220.473C223.248 117.626 225.497 115.378 225.497 112.606V76.2394C225.497 73.4667 223.248 71.219 220.473 71.219Z"
      fill="url(#paint1_linear_4322_5100)"
    />
    <path
      d="M104.854 66.0439H67.576C64.8014 66.0439 62.5522 68.2917 62.5522 71.0644V107.431C62.5522 110.203 64.8014 112.451 67.576 112.451H104.854C107.628 112.451 109.877 110.203 109.877 107.431V71.0644C109.877 68.2917 107.628 66.0439 104.854 66.0439Z"
      fill="url(#paint2_linear_4322_5100)"
    />
    <path
      d="M91.0875 135.618H53.8098C51.0353 135.618 48.7861 137.866 48.7861 140.638V177.005C48.7861 179.777 51.0353 182.025 53.8098 182.025H91.0875C93.862 182.025 96.1112 179.777 96.1112 177.005V140.638C96.1112 137.866 93.862 135.618 91.0875 135.618Z"
      fill="url(#paint3_linear_4322_5100)"
    />
    <path
      d="M215.321 190.332L214.797 190.198L223.607 156.365H239.492V156.909H224.031L215.321 190.332Z"
      fill="#7494FF"
    />
    <path
      d="M178.219 104.299H170.909L151.09 170.922L150.625 170.875L170.492 103.755H178.219V104.299Z"
      fill="#7494FF"
    />
    <path
      d="M139.932 155.303L122.474 100.569H108.842V100.024H122.871L122.931 100.219L140.45 155.135L139.932 155.303Z"
      fill="#7494FF"
    />
    <path
      d="M119.804 176.037L107.389 162.205H95.2168V161.661H107.631L120.214 175.674L119.804 176.037Z"
      fill="#7494FF"
    />
    <path
      d="M155.831 166.829C155.52 170.537 153.827 173.993 151.086 176.511C148.346 179.03 144.758 180.427 141.035 180.426H140.948V175.257C143.302 175.242 145.572 174.383 147.346 172.837C149.119 171.29 150.278 169.158 150.612 166.829H155.831Z"
      fill="#7494FF"
    />
    <path
      d="M155.831 166.648C155.52 170.356 153.827 173.811 151.086 176.33C148.346 178.848 144.758 180.245 141.035 180.244H140.948V175.069C143.301 175.056 145.571 174.198 147.345 172.652C149.119 171.107 150.278 168.976 150.612 166.648H155.831Z"
      fill="url(#paint4_linear_4322_5100)"
    />
    <path
      d="M105.56 180.688L111.377 169.417L124.525 177.092L114.558 197.08L107.779 191.891L105.56 180.688Z"
      fill="white"
    />
    <path d="M196.607 86.6307H185.135V87.4705H196.607V86.6307Z" fill="#7494FF" />
    <path d="M192.137 88.255H185.135V89.0427H192.137V88.255Z" fill="#7494FF" />
    <path d="M216.995 88.255H194.962V89.0492H216.995V88.255Z" fill="#7494FF" />
    <path d="M198.404 89.8826H188.776V90.7126H198.404V89.8826Z" fill="#7494FF" />
    <path d="M203.338 91.5068H191.866V92.3466H203.338V91.5068Z" fill="#7494FF" />
    <path d="M213.7 91.5068H204.085V92.4378H213.7V91.5068Z" fill="#7494FF" />
    <path d="M200.708 93.1311H191.849V93.9188H200.708V93.1311Z" fill="#7494FF" />
    <path d="M219.834 93.1311H201.556V94.0035H219.834V93.1311Z" fill="#7494FF" />
    <path d="M196.607 95.3283H185.135V96.1681H196.607V95.3283Z" fill="#7494FF" />
    <path d="M192.137 96.9526H185.135V97.7403H192.137V96.9526Z" fill="#7494FF" />
    <path d="M216.995 96.9526H194.962V97.7468H216.995V96.9526Z" fill="#7494FF" />
    <path d="M198.404 98.5768H188.776V99.4069H198.404V98.5768Z" fill="#7494FF" />
    <path d="M203.338 100.204H191.866V101.044H203.338V100.204Z" fill="#7494FF" />
    <path d="M213.7 100.204H204.085V101.135H213.7V100.204Z" fill="#7494FF" />
    <path d="M200.708 101.829H191.849V102.616H200.708V101.829Z" fill="#7494FF" />
    <path d="M219.834 101.829H201.556V102.701H219.834V101.829Z" fill="#7494FF" />
    <g clipPath="url(#clip0_4322_5100)">
      <path
        d="M96.4005 90L91.4505 85.05L92.8645 83.636L99.2285 90L92.8645 96.364L91.4505 94.95L96.4005 90Z"
        fill="#7494FF"
      />
    </g>
    <g clipPath="url(#clip1_4322_5100)">
      <path
        d="M76.0565 90L81.0065 94.95L79.5925 96.364L73.2285 90L79.5925 83.636L81.0065 85.05L76.0565 90Z"
        fill="#7494FF"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4322_5100"
        x1={272.398}
        y1={-14.7066}
        x2={258.589}
        y2={237.762}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.02} stopColor="white" stopOpacity={0} />
        <stop offset={0.14} stopColor="white" stopOpacity={0.06} />
        <stop offset={0.32} stopColor="white" stopOpacity={0.39} />
        <stop offset={0.68} stopColor="white" stopOpacity={0.68} />
        <stop offset={1} stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4322_5100"
        x1={215.073}
        y1={-147.181}
        x2={201.257}
        y2={105.288}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.02} stopColor="white" stopOpacity={0} />
        <stop offset={0.32} stopColor="white" stopOpacity={0.39} />
        <stop offset={0.68} stopColor="white" stopOpacity={0.68} />
        <stop offset={1} stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_4322_5100"
        x1={95.9293}
        y1={-88.0711}
        x2={82.1135}
        y2={164.397}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.02} stopColor="white" stopOpacity={0} />
        <stop offset={0.32} stopColor="white" stopOpacity={0.39} />
        <stop offset={0.68} stopColor="white" stopOpacity={0.68} />
        <stop offset={1} stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_4322_5100"
        x1={82.0354}
        y1={-16.2658}
        x2={68.2264}
        y2={236.203}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.02} stopColor="white" stopOpacity={0} />
        <stop offset={0.32} stopColor="white" stopOpacity={0.39} />
        <stop offset={0.68} stopColor="white" stopOpacity={0.68} />
        <stop offset={1} stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_4322_5100"
        x1={137.928}
        y1={158.993}
        x2={163.106}
        y2={193.822}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.02} stopColor="white" stopOpacity={0} />
        <stop offset={0.32} stopColor="white" stopOpacity={0.39} />
        <stop offset={0.68} stopColor="white" stopOpacity={0.68} />
        <stop offset={1} stopColor="white" />
      </linearGradient>
      <clipPath id="clip0_4322_5100">
        <rect width={24} height={24} fill="white" transform="translate(107.229 102) rotate(-180)" />
      </clipPath>
      <clipPath id="clip1_4322_5100">
        <rect width={24} height={24} fill="white" transform="translate(65.2285 78)" />
      </clipPath>
    </defs>
  </svg>
);
export default React.memo(Dashboard);
